import { render, staticRenderFns } from "./actionplan-pdf-question.vue?vue&type=template&id=7c30a13f&scoped=true&"
import script from "./actionplan-pdf-question.vue?vue&type=script&lang=js&"
export * from "./actionplan-pdf-question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c30a13f",
  null
  
)

export default component.exports